import Button from "@/components/Button";
import DateSelect from "@/components/DateSelect";
import useModal from "@/hooks/useModal";
import { useQuery } from "@apollo/client";
import { Controller, useForm } from "react-hook-form";
import { ORDERS_QUERY } from "../queries";
import { DateTime } from "luxon";
import { ChangeDueDateModalProps } from "./ChangeDueDateModal";

interface SuspendModalProps extends ChangeDueDateModalProps {
  suspendAll: boolean;
  totalPeople: number | null;
}

export const SuspendModal = ({
  onDismiss,
  orders,
  suspendAll,
  totalPeople,
  loading,
  onSubmit,
  errorContent
}: SuspendModalProps) => {
  const { control, watch } = useForm();
  const headline = `Suspend People`;
  const orderIds = Object.keys(orders);
  const { data } = useQuery(ORDERS_QUERY, { variables: { ids: orderIds }, skip: !orderIds.length });
  const { close, Modal } = useModal();
  const currentDate = DateTime.now().toISO();

  const suspensionDateRange = watch("suspensionDate", {
    startDate: currentDate,
    endDate: currentDate
  });

  const personIds = data?.duesOrders?.nodes.map((order: any) => order.person.id) || null;
  const variables = {
    ...(!suspendAll && { personIds }),
    suspensionDate: suspensionDateRange.startDate
  };

  return (
    <Modal
      onClosed={onDismiss}
      action={
        <Button onClick={() => onSubmit(variables, close)} disabled={loading || !suspensionDateRange.startDate}>
          Suspend {suspendAll ? totalPeople : personIds?.length} People
        </Button>
      }
      headline={headline}
      displayOverflow
    >
      {errorContent ? <div className="text-red-500 font-bold text-center mb-4">{errorContent}</div> : null}
      <p className="mb-3 text-label-large">
        Total People to be Suspended: {suspendAll ? totalPeople : personIds?.length}
      </p>
      <p className="my-3">
        Are you sure you wish to suspend {suspendAll ? totalPeople : personIds?.length} people from their PGA program?
        They will still be able to pay their Dues until they are formally terminated.
      </p>
      <p>Suspended people will be sent an email notification.</p>
      <div className="mt-6">
        <input className="mt-4 ml-1 absolute"></input>

        <Controller
          name="suspensionDate"
          control={control}
          render={({ field }) => (
            <DateSelect
              label="Suspension Effective Date *"
              useModal={true}
              value={suspensionDateRange}
              onChange={(e) => {
                field.onChange(e);
              }}
              useSingleDate
              showFooter={false}
            />
          )}
        />
      </div>
    </Modal>
  );
};
